import type { ServiceType } from './service-types';

/**
 * The Website's public address (ARCHITECTURE_CORRECTION_PLAN §G, OD-6): informational, Website
 * services only, http/https only. It is never a vendor control-panel or login link, and no vendor
 * credentials are stored anywhere in the portal.
 */
export const ACCESS_URL_MAX_LENGTH = 2048;

export function serviceTypeHasAccessLink(type: ServiceType): boolean {
  return type === 'website';
}

/** True for an absolute URL with the http or https scheme and a host. */
export function isHttpUrl(value: string): boolean {
  if (value.length > ACCESS_URL_MAX_LENGTH) return false;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false;
  }
  return (url.protocol === 'http:' || url.protocol === 'https:') && url.hostname.length > 0;
}
